import { useState, useEffect } from 'react';

/**
 * Custom hook to manage view mode selection and persistence
 * @param {string} collectionType - Type of collection for localStorage key
 * @returns {Object} View mode state and change handler
 */
const useViewMode = (collectionType) => {
  // Initialize from localStorage or default to 'grid'
  const [viewMode, setViewMode] = useState(() => {
    const savedMode = localStorage.getItem(`${collectionType}CollectionViewMode`);
    console.log(`Loading view mode for ${collectionType}:`, savedMode);
    return savedMode || 'grid';
  });

  // Ensure the view mode is saved whenever it changes
  useEffect(() => {
    console.log(`Saving view mode for ${collectionType}:`, viewMode);
    localStorage.setItem(`${collectionType}CollectionViewMode`, viewMode);
  }, [collectionType, viewMode]);

  // Handle view mode change
  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      console.log(`Changing view mode for ${collectionType} to:`, newViewMode);
      setViewMode(newViewMode);
    }
  };

  return {
    viewMode,
    setViewMode,
    handleViewModeChange
  };
};

export default useViewMode;
